import styled from 'styled-components';

export const ContainerOT = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
  gap: 4rem;
  @media (max-width: ${({ theme }) => theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    gap: 2.8rem;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.xs};
  margin-bottom: ${({ theme }) => theme.spacing.m};
  align-items: center;
  flex-wrap: wrap;

  /* Sin nada dentro (la tablet en el RV sin fotos: no crea nada desde aquí,
     2026-10-09) la fila no mide nada pero su margen sí, y empujaba la primera
     tarjeta hacia abajo. Con :empty vale para cualquier combinación de
     botones sin tener que repetir aquí sus condiciones. */
  &:empty {
    display: none;
  }
`;

export const ActionMenuContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const ActionMenuList = styled.div`
  position: absolute;
  top: calc(100% + 0.5rem);
  left: 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs};
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.greyLight};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  padding: ${({ theme }) => theme.spacing.xs};
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 100;
  min-width: max-content;
  
  /* Botones internos al dropdown con 100% de ancho */
  button {
    width: 100%;
    justify-content: flex-start;
  }
`;

export const Container = styled.div`
  width: 100%;
`;

export const InfoMessage = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs};
  padding: ${({ theme }) => theme.spacing.s} ${({ theme }) => theme.spacing.m};
  background-color: ${({ theme }) => theme.colors.blueSoft}15;
  border: 1px solid ${({ theme }) => theme.colors.blue};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  color: ${({ theme }) => theme.colors.blue};
  font-size: ${({ theme }) => theme.fontSize.S};
  margin-bottom: ${({ theme }) => theme.spacing.m};

  svg {
    flex-shrink: 0;
    width: 1.6rem;
    height: 1.6rem;
  }
`;
